import { type FC } from 'react';
import { TextEllipsis } from '__components/Kizen/Table';
import { useTooltip } from '__components/Kizen/Tooltip';

export const ValueWithTooltip: FC<{ text: string; tooltip: string }> = ({
  text,
  tooltip,
}) => {
  const [dateTooltipProps, dateTooltip] = useTooltip(
    {
      label: tooltip,
    },
    () => true
  );
  return (
    <div>
      {dateTooltip}
      <TextEllipsis {...dateTooltipProps}>{text}</TextEllipsis>
    </div>
  );
};
